import "./AccountFlyoutAccountSwitch.scss";

import * as React from "react";
import { BusinessAccount, BusinessAccountResponse } from "../../../../../datatypes/businessaccounts/BusinessAccount";

type Props = {
    businessAccount: BusinessAccountResponse;
    setPageNumber: (pageNumber: number) => void;
};

export function AccountFlyoutAccountSwitch(props: Props) {
    const activeAccount: BusinessAccount | undefined | null = props.businessAccount.getActiveAccount();

    return (
        <div className="switch-section">
            <div className="switch-account-details">
                <div className="business-name">{activeAccount?.corporateName}</div>
                <div className="online-only">Online és áruházi hozzáférés</div>
            </div>
            <div className="switch-account" onClick={() => props.setPageNumber(2)}>
                <div className="switch-account-svg">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="32px"
                        height="32px"
                        viewBox="0 0 32 32"
                        version="1.1">
                        <defs>
                            <path
                                d="M20.0952,16.0892 C20.4852,15.6982 21.1182,15.6982 21.5092,16.0892 L21.5092,16.0892 L28.1102,22.6892 C28.2022,22.7802 28.2752,22.8902 28.3262,23.0122 C28.3772,23.1342 28.4042,23.2632 28.4042,23.3972 C28.4042,23.5312 28.3772,23.6612 28.3262,23.7822 C28.2752,23.9042 28.2022,24.0142 28.1102,24.1052 L28.1102,24.1052 L21.5092,30.7072 C21.3132,30.9022 21.0572,31.0002 20.8022,31.0002 C20.5462,31.0002 20.2902,30.9022 20.0952,30.7072 C19.7042,30.3162 19.7042,29.6832 20.0952,29.2932 L20.0952,29.2932 L24.9902,24.3972 L4.2972,24.3972 C3.7442,24.3972 3.2972,23.9502 3.2972,23.3972 C3.2972,22.8452 3.7442,22.3972 4.2972,22.3972 L4.2972,22.3972 L24.9902,22.3972 L20.0952,17.5032 C19.7042,17.1122 19.7042,16.4792 20.0952,16.0892 Z M10.3092,1.2932 C10.7002,1.6832 10.7002,2.3162 10.3092,2.7072 L5.4142,7.6022 L26.1072,7.6022 C26.6602,7.6022 27.1072,8.0502 27.1072,8.6022 C27.1072,9.1552 26.6602,9.6022 26.1072,9.6022 L5.4142,9.6022 L10.3092,14.4972 C10.7002,14.8872 10.7002,15.5202 10.3092,15.9112 C10.1142,16.1062 9.8582,16.2042 9.6022,16.2042 C9.3472,16.2042 9.0912,16.1062 8.8952,15.9112 L2.2942,9.3102 C2.2022,9.2192 2.1282,9.1092 2.0772,8.9872 C2.0272,8.8672 2.0002,8.7362 2.0002,8.6022 C2.0002,8.4692 2.0272,8.3382 2.0772,8.2182 C2.1282,8.0952 2.2022,7.9862 2.2942,7.8942 L8.8952,1.2932 C9.2862,0.9022 9.9192,0.9022 10.3092,1.2932 Z"
                                id="path-2"
                            />
                        </defs>
                        <g id="Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Icon-/-medium-/-swap-business">
                                &lt; rect id="fill" x="0" y="0" width="32" height="32" /&gt;
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-2" />
                                </mask>
                                <use id="color" fill="#ffffff" xlinkHref="#path-2" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="switch-account-label">Fiókváltás</div>
            </div>
        </div>
    );
}
